import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSessionStore } from '@/store/session-store';

/**
 * Sends an unauthenticated visitor back to the login screen (US-001 AC-007).
 *
 * This is navigation, not authorization: it keeps the provider from landing on an empty screen. Every
 * protected read is verified server-side by portal-backend, which never trusts this state.
 */
export function RequireProviderSession(): React.JSX.Element {
  const providerId = useSessionStore((state) => state.providerId);
  const location = useLocation();

  if (providerId === null) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
